import React, { useEffect, useState } from 'react'
import PageHeading from '../../components/PageHeading'
import ProjectCard from './ProjectCard'
import AddProjectModal from './AddProjectModal'
import GetProject from '../../APIs/Project/GetProject'
import { Link } from 'react-router-dom'

export default function AllProject() {

    let [loader, setLoader] = useState(1)
    let [projects, setProjects] = useState([])
    let [pageNumber, setPageNumber] = useState(1)
    let [pageSize, setPageSize] = useState(10)
    let [numberPages, setNumberOfPages] = useState([])

    let getData = async () => {
        try {
            let allProjects = await GetProject();
            if (allProjects.status === 1) {
                setProjects(allProjects.responseValue.reverse());
                // console.log("Math.round(allProjects.responseValue/pageSize)",allProjects.responseValue/pageSize))
                setNumberOfPages(Math.round(allProjects.responseValue.length / pageSize) === 0 ? [0] : new Array(Math.round(allProjects.responseValue.length / pageSize)).fill(0))
                setLoader(0);
            } else {
                setNumberOfPages([])
                setLoader(0);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            setLoader(0);
        }
    }

    const handlePrevious = () => {
        if (pageNumber !== 1) {
            setPageNumber(state => state - 1)
        }
        else {

        }
    }
    const handleNext = () => {
        if (pageNumber < numberPages?.length) {
            setPageNumber(state => state + 1);
        }
    };
    useEffect(() => {
        getData()
        window.sessionStorage.removeItem("ProjectData")
    }, [])

    return (
        <>
            <div className='d-flex flex-column flex-md-row justify-content-between pe-3 ps-3'>
                <PageHeading pagename={"Project Management"} />
                <button className="btn btn-primary" type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#addproject">+ Add New Project</button>
            </div>
            <div className='container-fluid  pt-4'>
                <div className='project-conatiner mb-4'>
                    {
                        projects && projects.slice(((pageSize * pageNumber) - pageSize), pageSize * pageNumber).map((val, ind) => {
                            return (
                                <ProjectCard projectData={val} getData={getData} />
                            )
                        })
                    }

                </div>
                {projects?.length > 10 && (
                    <nav aria-label="Page navigation">
                        <ul className="pagination justify-content-end">

                            <li className={`page-item ${pageNumber === 1 ? "disabled" : ""}`}>
                                <Link
                                    className="page-link"
                                    to="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handlePrevious();
                                    }}
                                >
                                    Previous
                                </Link>
                            </li>

                            {numberPages?.map((val, ind) => (
                                <li
                                    className={`page-item ${pageNumber === ind + 1 ? "active" : ""}`}
                                    key={ind}
                                >
                                    <Link
                                        className="page-link"
                                        to="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setPageNumber(ind + 1);
                                        }}
                                    >
                                        {ind + 1}
                                    </Link>
                                </li>
                            ))}

                            <li
                                className={`page-item ${pageNumber === numberPages?.length ? "disabled" : ""
                                    }`}
                            >
                                <Link
                                    className="page-link"
                                    to="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleNext();
                                    }}
                                >
                                    Next
                                </Link>
                            </li>

                        </ul>
                    </nav>
                )}
            </div>

            <AddProjectModal />

        </>
    )
}